import { render } from "./SettingsList.vue?vue&type=template&id=2f3af604&scoped=true&ts=true"
import script from "./SettingsList.vue?vue&type=script&lang=ts"
export * from "./SettingsList.vue?vue&type=script&lang=ts"

import "./SettingsList.vue?vue&type=style&index=0&id=2f3af604&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3af604"]])

export default __exports__